import { CONTINUOUS_BLOCK } from '../../../types/BlockTypes';
export var WRAPPER_BLOCKS = Object.values(CONTINUOUS_BLOCK);
export var IGNORED_OPERATIONS = ['set_selection', 'set_value'];
export var BLOCK_DELIMITER = '\n';
export var BLOCK_DELIMITER_LENGTH = BLOCK_DELIMITER.length;